import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import * as fileSaver from 'file-saver';
import { Label } from 'ng2-charts';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { CategoryPipe } from '../../../pipes/category.pipe';
import { TransportPipe } from '../../../pipes/transport.pipe';
import { ChartUiService } from '../../../services/chart.ui.service';
@Component({
  selector: 'app-analysis-report',
  templateUrl: './analysis-report.component.html',
  styleUrls: ['./analysis-report.component.scss'],
})
export class AnalysisReportComponent implements OnInit {
  //bar
  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{}], yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: function (value) { if (Number(value) % 1 === 0) { return value; } }
        }
      }]
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 30,
        bottom: 0
      }
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'top',
        formatter: Math.round,
        font: {
          weight: 'bold'
        }
      }
    }
  };
  public barChartLabels: Label[] = [];
  public isBarChartLoaded = false;
  public barChartType: ChartType = 'bar';
  public barChartLegend = false;
  public barChartPlugins = [pluginDataLabels];

  private dataSet = [];
  public barChartData: ChartDataSets[] = [];


  // Pie 1
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'right',
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          var dataset: any = data.datasets[tooltipItem.datasetIndex];
          var meta = dataset._meta[Object.keys(dataset._meta)[0]];
          var total = meta.total;
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = parseFloat((currentValue / total * 100).toFixed(2));
          return percentage + '%';
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr: any[] = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            sum += parseFloat(data);
          });
          const percentage = (parseFloat(value) * 100 / sum);
          if (percentage == 0) return '';
          return parseFloat(percentage.toFixed(2)) + '%';
        }
      }
    }
  };
  public pieCategory: number[] = [];
  public isPieCategoryLoaded = false;
  public pieLabelsCategory: Label[] = [];
  public pieTypeOfUsers: number[] = [];
  public isPieTypeOfUsersLoaded = false;
  public pieLabelsTypeOfUsers: Label[] = [];
  public pieTypeOfTransports: number[] = [];
  public isPieTypeOfTransportsLoaded = false;
  public pieLabelsTypeOTransports: Label[] = [];
  public pieProjects: number[] = [];
  public isPieProjectsLoaded = false;
  public pieLabelsProjects: Label[] = [];
  public pieTypeOStatus: number[] = [];
  public isPieTypeOStatusLoaded = false;
  public pieLabelsTypeOStatus: Label[] = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChart10Colors = [
    {
      backgroundColor: [
        '#e57676', '#7eb95e', '#448db2', '#f0b958',
        '#e573a1', '#9cb93f', '#4bb29c', '#f08057',
        '#a6e5b8', '#9ca0b9', '#b28ad6'
      ],
    },
  ];
  shortMonths = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

  public translateCategories: string[] = [];
  public translateTypeofUsers: string[] = [];
  public translateTypeOTransports: string[] = [];
  public translateProjects: string[] = [];
  public translateTypeoStatus: string[] = [];
  public exportReportToPpt = environment.exportReportToPpt
  constructor(
    private chartService: ChartUiService,
    private categoryPipe: CategoryPipe,
    private transportPipe: TransportPipe,
    private translate: TranslateService,
    private service: DataService,
  ) {
    this.barChartData = [
      {
        data: this.dataSet,
        backgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#448db2', '#f0b958'),
        borderColor: '#448db2',
        hoverBackgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#334967', '#ad8b34'),
        hoverBorderColor: '#334967',
        hideInLegendAndTooltip: true
      }
    ];
  }

  ngOnInit() {
    const year = new Date().getFullYear();

    this.translate.onLangChange.subscribe((e) => {
      this.translateChartLabels();
    });

    this.chartService.ticketPerMonth(year).subscribe(response => {
      const res = response.map(it => {
        return {
          ...it,
          t3: this.shortMonths.indexOf(it.t1),
          t4: `${year}-${("0" + (this.shortMonths.indexOf(it.t1) + 1)).slice(-2)}`
        }
      }).sort(function (a, b) {
        return a.t3 - b.t3;
      });

      this.barChartLabels = res.map(it => it.t4);
      this.dataSet = res.map(it => it.t2);
      this.barChartData = [
        {
          data: this.dataSet,
          backgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#448db2', '#f0b958'),
          borderColor: '#448db2',
          hoverBackgroundColor: this.chartService.colorsMaxValue(this.dataSet, '#334967', '#ad8b34'),
          hoverBorderColor: '#334967',
          hideInLegendAndTooltip: true
        }
      ];
      this.isBarChartLoaded = true;
    });
    this.chartService.ticketPerStatus().subscribe(response => {
      this.pieTypeOStatus = response.map(it => it.t2);
      this.translateTypeoStatus = response.map(it => it.t1.toLowerCase());
      this.translate.get(this.translateTypeoStatus)
        .subscribe(translations => {
          this.pieLabelsTypeOStatus = Object.values(translations)
        });
      this.isPieTypeOStatusLoaded = true;
    });

    this.chartService.ticketPerTransportMode().subscribe(response => {
      this.pieTypeOfTransports = response.map(it => it.t2);
      this.translateTypeOTransports = response.map(it => this.transportPipe.transform(it.t1));
      this.translate.get(this.translateTypeOTransports)
        .subscribe(translations => {
          this.pieLabelsTypeOTransports = Object.values(translations)
        });
      this.isPieTypeOfTransportsLoaded = true;
    });

    this.chartService.ticketPerUserType().subscribe(response => {
      this.pieTypeOfUsers = response.map(it => it.t2 === 'NaN' ? 0 : it.t2);
      this.translateTypeofUsers = response.map(it => it.t1.toLowerCase());
      this.translate.get(this.translateTypeofUsers)
        .subscribe(translations => {
          this.pieLabelsTypeOfUsers = Object.values(translations)
        });
      this.isPieTypeOfUsersLoaded = true;

    });

    this.chartService.ticketPerCategory().subscribe(response => {
      this.pieCategory = response.map(it => it.t2);
      this.translateCategories = response.map(it => this.categoryPipe.transform(it.t1));
      this.translate.get(this.translateCategories)
        .subscribe(translations => {
          this.pieLabelsCategory = Object.values(translations)
        });
      this.isPieCategoryLoaded = true;
    });

    this.chartService.ticketPerProject().subscribe(response => {
      this.pieProjects = response.map(it => it.t3);
      this.translateProjects = response.map(it => it.t2);
      this.translate.get(this.translateProjects)
        .subscribe(translations => {
          this.pieLabelsProjects = Object.values(translations)
        });
      this.isPieProjectsLoaded = true;
    });
  }

  getReportAnalysis() {
    const browserLang = this.translate.currentLang;
    const selectedLang = browserLang === 'SPA'? 'ESP': browserLang;
    const project = JSON.parse(localStorage.getItem('project_id'));
    this.service.getTicketReport('XLSX', selectedLang)
      .subscribe(response => {
        let blob: any = new Blob([response], { type: 'application/vnd.ms.excel' });
        const reportName = `${project!.projectName}-${Date.now()}.xlsx`;
        fileSaver.saveAs(blob, reportName);
      });
  }

  generateProjectReport() {
    const browserLang = this.translate.currentLang;
    const project = JSON.parse(localStorage.getItem('project_id'));
    this.service.generateReport(browserLang)
      .subscribe(response => {
        let blob: any = new Blob([response], { type: 'application/vnd.ms-powerpoint' });
        const reportName = `${project!.projectName}-${Date.now()}.zip`;
        fileSaver.saveAs(blob, reportName);
      });
  }

  translateChartLabels() {
    if (this.translateProjects.length) {
      this.translate.get(this.translateProjects)
        .subscribe(translations => {
          this.pieLabelsProjects = Object.values(translations)
        });
    }
    if (this.translateCategories.length) {
      this.translate.get(this.translateCategories)
        .subscribe(translations => {
          this.pieLabelsCategory = Object.values(translations)
        });
    }
    if (this.translateTypeoStatus.length) {
      this.translate.get(this.translateTypeoStatus)
        .subscribe(translations => {
          this.pieLabelsTypeOStatus = Object.values(translations)
        });
    }
    if (this.translateTypeOTransports.length) {
      this.translate.get(this.translateTypeOTransports)
        .subscribe(translations => {
          this.pieLabelsTypeOTransports = Object.values(translations)
        });
    }
    if (this.translateTypeofUsers.length) {
      this.translate.get(this.translateTypeofUsers)
        .subscribe(translations => {
          this.pieLabelsTypeOfUsers = Object.values(translations)
        });
    }
  }
}
